import React, { useCallback, useState } from "react";
import { SendRequest } from "../../util/AxiosUtil";
import SalesTrackingTable from "../../components/Tables/SalesTrackingTable";
import TransactionsTable from "../../components/Tables/TransactionsTable";
const SalesTracking = () => {
  const [data, setData] = useState([]);
  const handleClick = useCallback((row, col) => {
    switch (row) {
      case 0:
        SendRequest({
          url: "Admin/get-transactions",
          method: "post",
          data: {
            Type: col,
          },
        }).then((result) => {
          setData(result.data);
        });
        break;
      default:
        break;
    }
  }, []);
  return (
    <>
      <SalesTrackingTable handleClick={handleClick} />
      <hr />
      <TransactionsTable transactions={data} />
    </>
  );
};

export default SalesTracking;
